import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../globalInspector/axiosInstance";
import { env } from "../../../env";
import { toast } from "react-toastify";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
const baseUrl = env.REACT_APP_BASE_URL;

export const getAllPrivateTransactions = createAsyncThunk(
  "getAllPrivateTransactions",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      status,
      owner_account_id,
      owner_account_ifsc_code,
      from_date,
      to_date,
      private_transaction_id,
      entity_id,
      category,
      amount,
      distribution_lifecycle_status,
      labels,
    } = values;
    try {
      const response = await axiosInstance.get(
        `${status === "require approval" ? `${baseUrl}/transactions/private_transactions/actionable` : `${baseUrl}/transactions/private_transaction_requests`}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page_no ? page_no : undefined,
            page_size: page_size ? page_size : undefined,
            status:
              status === "pending_for_otp"
                ? [status, "otp_submitted", "otp_requested"]
                : [status],
            distribution_lifecycle_status: distribution_lifecycle_status,
            owner_account_id: owner_account_id,
            from_date: from_date,
            to_date: to_date,
            private_transaction_id: private_transaction_id,
            entity_id: entity_id,
            category: category,
            amount: amount,
            owner_account_ifsc_code,
            labels: labels,
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error?.base?.[0] ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      // CommonToast({
      //   text: errorMessage,
      //   icon: ICONS?.ERROR_WHITE_CIRCLE,
      //   variant: "var(--error)",
      //   buttonNeeded: false,
      // });

      return rejectWithValue(errorMessage);
    }
  },
);

export const getSpecificPrivateTransactions = createAsyncThunk(
  "getSpecificPrivateTransactions",
  async (payload, { rejectWithValue }) => {
    const { id } = payload;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/private_transactions/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const createPrivateTransaction = createAsyncThunk(
  "createPrivateTransaction",
  async (
    { category, owner_account_id, uploaded_file_data, labels },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/transaction/bulk_payment`,
        {
          category,
          owner_account_id,
          uploaded_file_data,
          labels,
        },
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const getPrivateSampleCsv = createAsyncThunk(
  "getPrivateSampleCsv",
  async ({ category }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/private_transactions/sample_file.xlsx`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            category: category,
          },
          responseType: "blob",
        },
      );
      let blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `${category}_sample_file.xlsx`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      CommonToast({
        text: "Sample file downloaded successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);

        errorMessage =
          parsed?.error?.base ||
          parsed?.error?.message ||
          parsed?.message ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);

export const addNewLabelPvt = createAsyncThunk(
  "addNewLabelPvt",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transaction/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();
      CommonToast({
        text: "Label assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      if (error?.response?.data?.errors?.user_unauthorized?.[0]) {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const approvePrivateTxn = createAsyncThunk(
  "approvePrivateTxn",
  async ({ id }, { rejectWithValue }) => {
    const data = {
      private_transaction: {
        txn_id: id,
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transactions/approve`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const rejectPrivateTxn = createAsyncThunk(
  "rejectPrivateTxn",
  async ({ id, reason }, { rejectWithValue }) => {
    const data = {
      private_transaction: {
        txn_id: id,
        rejection_reason: reason,
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transactions/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const removeNewLabelPvt = createAsyncThunk(
  "removeNewLabelPvt",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transaction/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      CommonToast({
        text: "Label unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",

        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

// export const rejectPrivateTxn = createAsyncThunk(
//   "Privatetransactions/rejectPrivateTxn",
//   async ({ id, rejection_reason }, thunkAPI) => {
//     try {
//       const body = {
//         private_transaction: {
//           status: "reject",
//           rejection_reason: rejection_reason,
//         },
//       };
//       const response = await fetch(
//         `${baseUrl}/transactions/private_transactions/${id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Api-Key": sessionStorage.getItem("q2p_token"),
//           },
//           body: JSON.stringify(body),
//         },
//       );
//       if (!response.ok) {
//         throw new Error("Failed to update status");
//       }

//       return await response.json();
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   },
// );

export const ApprovePrivateTxn = createAsyncThunk(
  "Privatetransactions/approvePrivateTxn",
  async ({ id }, thunkAPI) => {
    try {
      const body = {
        private_transaction: {
          status: "approve",
        },
      };
      const response = await fetch(
        `${baseUrl}/transactions/private_transactions/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          body: JSON.stringify(body),
        },
      );
      if (!response.ok) {
        throw new Error("Failed to update status");
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const ValidateEntries = createAsyncThunk(
  "validateEntries",
  async ({ private_transaction_id, narration }, { rejectWithValue }) => {
    try {
      const data = {
        private_transaction: {
          txn_id: [private_transaction_id],
          narration: narration,
        },
      };

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transactions/validate`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (!response.data?.status) {
        return rejectWithValue(response.data || "Validation failed");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const invalidPrivateTxnEntry = createAsyncThunk(
  "invalidateEntries",
  async ({ private_transaction_id, rejection_reason }, { rejectWithValue }) => {
    try {
      const data = {
        private_transaction: {
          txn_id: [private_transaction_id],
          rejection_reason: rejection_reason,
        },
      };

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transactions/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (!response.data?.status) {
        return rejectWithValue(response.data || "Rejection failed");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getSpecificTransactionItems = createAsyncThunk(
  "getSpecificTransactionItems",
  async (payload, { rejectWithValue }) => {
    const { private_transaction_id } = payload;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/private_transactions/${private_transaction_id}/transaction_items`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const otpValidation = createAsyncThunk(
  "otpValidation",
  async ({ otp, id }, { rejectWithValue }) => {
    const data = {
      private_transaction: {
        otp: otp,
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transactions/${id}/validate_otp`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();
      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const otpSend = createAsyncThunk(
  "otpSend",
  async ({ otp, id }, { rejectWithValue }) => {
    const data = {
      private_transaction: {
        otp: otp,
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transactions/${id}/request_otp`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      CommonToast({
        text: error?.response?.data?.errors?.base[0],
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return rejectWithValue(error);
    }
  },
);

export const otpResend = createAsyncThunk(
  "otpResend",
  async ({ otp, id }, { rejectWithValue }) => {
    const data = {
      private_transaction: {
        otp: otp,
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/private_transactions/${id}/resend_otp`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      if (response?.status) {
        CommonToast({
          text: "OTP resent to the registered mobile number",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
const privatetransactions = createSlice({
  name: "privatetransactions",
  initialState: {
    allPrivateTransactionsData: [],
    allPrivateTransactionsLoading: false,
    allPrivateTransactionsError: false,

    specificPrivateTransactionsData: [],
    specificPrivateTransactionsLoading: false,
    specificPrivateTransactionsError: false,

    createPrivateTransactionLoading: false,
    createPrivateTransactionData: {},
    createPrivateTransactionError: false,

    getPrivateSampleCsvLoading: false,

    addLabelsPvtLoading: false,
    addLabelsPvtError: false,
    addLabelsPvtData: [],

    removeLabelsPvtLoading: false,
    removeLabelsPvtError: false,
    removeLabelsPvtData: [],

    ValidateEntriesData: [],
    ValidateEntriesisLoading: false,
    ValidateEntrieserror: null,

    getSpecificTransactionItemsLoading: false,
    getSpecificTransactionItemsData: [],
    getSpecificTransactionItemsError: null,

    invalidateEntriesData: [],
    invalidateEntriesisLoading: false,
    invalidateEntrieserror: null,
    togglePvt: false,

    approvePrivateTxnLoading: false,
    approvePrivateTxnError: false,
    approvePrivateTxnData: [],

    rejectPrivateTxnLoading: false,
    rejectPrivateTxnError: false,
    rejectPrivateTxnData: [],

    otpValidationLoading: false,
    otpValidationError: false,
    otpValidationData: [],

    otpSendLoading: false,
    otpSendError: false,
    otpSendData: [],

    otpResendLoading: false,
    otpResendError: false,
    otpResendData: [],
  },
  reducers: {
    setTogglePvt: (state, action) => {
      state.togglePvt = action.payload;
    },
    resetTogglePvt: (state) => {
      state.togglePvt = false;
    },
    resetpage: (state) => {
      state.storedPage = 1;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
    resetSpecificPrivateTxn: (state) => {
      state.specificPrivateTransactionsData = [];
      state.specificPrivateTransactionsLoading = false;
      state.specificPrivateTransactionsError = false;
    },
    resetOtpError: (state) => {
      state.otpValidationError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPrivateTransactions.pending, (state) => {
      state.allPrivateTransactionsLoading = true;
    });
    builder.addCase(getAllPrivateTransactions.fulfilled, (state, action) => {
      state.allPrivateTransactionsLoading = false;
      state.allPrivateTransactionsData = action.payload;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsPvt",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
    });
    builder.addCase(getAllPrivateTransactions.rejected, (state, action) => {
      state.allPrivateTransactionsError = true;
      state.allPrivateTransactionsLoading = false;
    });
    builder.addCase(getSpecificPrivateTransactions.pending, (state) => {
      state.specificPrivateTransactionsLoading = true;
    });
    builder.addCase(
      getSpecificPrivateTransactions.fulfilled,
      (state, action) => {
        state.specificPrivateTransactionsLoading = false;
        state.specificPrivateTransactionsData = action.payload;
      },
    );
    builder.addCase(
      getSpecificPrivateTransactions.rejected,
      (state, action) => {
        state.specificPrivateTransactionsError = true;
        state.specificPrivateTransactionsLoading = false;
      },
    );
    builder.addCase(createPrivateTransaction.pending, (state) => {
      state.createPrivateTransactionLoading = true;
    });
    builder.addCase(createPrivateTransaction.fulfilled, (state, action) => {
      state.createPrivateTransactionLoading = false;
      state.createPrivateTransactionData = action.payload;
    });
    builder.addCase(createPrivateTransaction.rejected, (state, action) => {
      state.createPrivateTransactionError = true;
      state.createPrivateTransactionLoading = false;
    });
    builder.addCase(getPrivateSampleCsv.pending, (state) => {
      state.getPrivateSampleCsvLoading = true;
    });
    builder.addCase(getPrivateSampleCsv.fulfilled, (state, action) => {
      state.getPrivateSampleCsvLoading = false;
    });
    builder.addCase(getPrivateSampleCsv.rejected, (state, action) => {
      state.getPrivateSampleCsvLoading = false;
    });

    builder.addCase(addNewLabelPvt.pending, (state, action) => {
      state.addLabelsPvtLoading = true;
    });
    builder.addCase(addNewLabelPvt.fulfilled, (state, action) => {
      state.addLabelsPvtLoading = false;
      state.addLabelsPvtData = action.payload;
    });
    builder.addCase(addNewLabelPvt.rejected, (state, action) => {
      state.addLabelsPvtLoading = false;
      state.addLabelsPvtError = action.payload;
      state.addLabelsPvtData = null;
    });
    builder.addCase(removeNewLabelPvt.pending, (state, action) => {
      state.removeLabelsPvtLoading = true;
    });
    builder.addCase(removeNewLabelPvt.fulfilled, (state, action) => {
      state.removeLabelsPvtLoading = false;
      state.removeLabelsPvtData = action.payload;
    });
    builder.addCase(removeNewLabelPvt.rejected, (state, action) => {
      state.removeLabelsPvtLoading = false;
      state.removeLabelsPvtError = action.payload;
      state.removeLabelsPvtData = null;
    });
    builder.addCase(ValidateEntries.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(ValidateEntries.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;

      const { id, status } = action.payload || {};

      if (!id) return;

      state.specificEntry = (state.specificEntry || []).map((txn) =>
        txn.id === id ? { ...txn, status } : txn,
      );
    });

    builder.addCase(ValidateEntries.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    builder.addCase(getSpecificTransactionItems.pending, (state) => {
      state.getSpecificTransactionItemsLoading = true;
    });
    builder.addCase(getSpecificTransactionItems.fulfilled, (state, action) => {
      state.getSpecificTransactionItemsLoading = false;
      state.getSpecificTransactionItemsData = action.payload;
      state.getSpecificTransactionItemsError = null;
    });
    builder.addCase(getSpecificTransactionItems.rejected, (state, action) => {
      state.getSpecificTransactionItemsLoading = false;
      state.getSpecificTransactionItemsError = action.payload;
    });

    builder.addCase(invalidPrivateTxnEntry.pending, (state) => {
      state.invalidateEntriesisLoading = true;
      state.invalidateEntrieserror = null;
    });
    builder.addCase(invalidPrivateTxnEntry.fulfilled, (state, action) => {
      state.invalidateEntriesisLoading = false;
      state.invalidateEntrieserror = null;

      const { id, status } = action.payload || {};

      if (!id) return;

      state.specificEntry = (state.specificEntry || []).map((txn) =>
        txn.id === id ? { ...txn, status } : txn,
      );
    });

    builder.addCase(invalidPrivateTxnEntry.rejected, (state, action) => {
      state.invalidateEntriesisLoading = false;
      state.invalidateEntrieserror = action.payload;
    });

    builder.addCase(approvePrivateTxn.pending, (state, action) => {
      state.approvePrivateTxnLoading = true;
    });
    builder.addCase(approvePrivateTxn.fulfilled, (state, action) => {
      state.approvePrivateTxnLoading = false;
      state.approvePrivateTxnData = action.payload;
    });
    builder.addCase(approvePrivateTxn.rejected, (state, action) => {
      state.approvePrivateTxnLoading = false;
      state.approvePrivateTxnError = action.payload;
      state.approvePrivateTxnData = null;
    });

    builder.addCase(rejectPrivateTxn.pending, (state, action) => {
      state.rejectPrivateTxnLoading = true;
    });
    builder.addCase(rejectPrivateTxn.fulfilled, (state, action) => {
      state.rejectPrivateTxnLoading = false;
      state.rejectPrivateTxnData = action.payload;
    });
    builder.addCase(rejectPrivateTxn.rejected, (state, action) => {
      state.rejectPrivateTxnLoading = false;
      state.rejectPrivateTxnError = action.payload;
      state.rejectPrivateTxnData = null;
    });

    builder.addCase(otpValidation.pending, (state, action) => {
      state.otpValidationLoading = true;
      state.otpValidationError = false;
    });
    builder.addCase(otpValidation.fulfilled, (state, action) => {
      state.otpValidationLoading = false;
      state.otpValidationData = action.payload;
    });
    builder.addCase(otpValidation.rejected, (state, action) => {
      state.otpValidationLoading = false;
      state.otpValidationError = true;
      state.otpValidationData = null;
    });

    builder.addCase(otpResend.pending, (state, action) => {
      state.otpResendLoading = true;
      state.otpResendError = false;
    });
    builder.addCase(otpResend.fulfilled, (state, action) => {
      state.otpResendLoading = false;
      state.otpResendData = action.payload;
    });
    builder.addCase(otpResend.rejected, (state, action) => {
      state.otpResendLoading = false;
      state.otpResendError = true;
      state.otpResendData = null;
    });

    builder.addCase(otpSend.pending, (state, action) => {
      state.otpSendLoading = true;
      state.otpSendError = false;
    });
    builder.addCase(otpSend.fulfilled, (state, action) => {
      state.otpSendLoading = false;
      state.otpSendData = action.payload;
    });
    builder.addCase(otpSend.rejected, (state, action) => {
      state.otpSendLoading = false;
      state.otpSendError = true;
      state.otpSendData = null;
    });
  },
});

export const {
  setStoredPage,
  setTogglePvt,
  resetTogglePvt,
  resetSpecificPrivateTxn,
  resetOtpError,
} = privatetransactions.actions;

export default privatetransactions.reducer;
